import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../../core/layout/Dialog';
import Icon from '../../../core/layout/Icon';
import PlacementTestReportTestDialogStats from './PlacementTestReportTestDialogStats';
import PlacementTestReportTestDialogAnsweredItemsBar from './PlacementTestReportTestDialogAnsweredItemsBar';
import Separator from '../../../core/layout/Separator';
import DetailErrorsPerAbilityChartContainer from './charts/DetailErrorsPerAbilityChartContainer';
import { get } from 'lodash';
import Async from '../../../core/layout/Async';
import DetailErrorsPerLevelChartContainer from './charts/DetailErrorsPerLevelChartContainer';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import DetailErrorsPerGrammarChartContainer from './charts/DetailErrorsPerGrammarChartContainer';
import PlacementTestReportTestDialogAnsweredQuestionList from './PlacementTestReportTestDialogAnsweredQuestionList';

export default function PlacementTestReportTestDialog(props) {
  const device = get(props.data, 'studentAccess')
    ? !!['android', 'android os', 'ios'].find((os) => os === props.data.studentAccess.os.toLowerCase())
      ? 'Mobile'
      : 'Web'
    : '';

  return (
    <Dialog
      title={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ fontSize: '22px', fontWeight: 'bold', marginRight: '15px' }}>
            {!props.isFetching ? get(props.data, 'student.name') : 'Loading...'}
          </span>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {!props.isFetching && (
              <>
                <Icon
                  name={device === 'Web' ? 'desktop' : 'mobile'}
                  style={{ fontSize: '24px', marginRight: '8px', color: '#808080' }}
                />
                <span style={{ fontSize: '14px', color: '#808080' }}>{device}</span>
              </>
            )}
          </div>
        </div>
      }
      isOpen={props.isOpen}
      onCancel={props.onClose}
      actions={null}
      width="95%"
    >
      <Async fetching={props.isFetching}>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'space-between',
            height: 'auto',
            width: '100%',
          }}
        >
          <div style={{ width: '59%' }}>
            <Separator size="sm" />
            <PlacementTestReportTestDialogStats data={props.data} />
            <Separator size="xl" />
            <PlacementTestReportTestDialogAnsweredItemsBar answeredItems={props.data.answeredItems} />
            <Separator size="xl" />
            <Row>
              <Column size={6}>
                <DetailErrorsPerAbilityChartContainer />
              </Column>
              <Column size={6}>
                <DetailErrorsPerLevelChartContainer />
              </Column>
            </Row>
            <Separator size="xs" />
            <Row>
              <Column size={12}>
                <DetailErrorsPerGrammarChartContainer />
              </Column>
            </Row>
            <Separator size="sm" />
          </div>
          <div style={{ width: '39%' }}>
            <PlacementTestReportTestDialogAnsweredQuestionList data={props.data.answeredItems} />
          </div>
        </div>
      </Async>
    </Dialog>
  );
}

PlacementTestReportTestDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
  data: PropTypes.object,
};

PlacementTestReportTestDialog.defaultProps = {
  isOpen: false,
  isFetching: false,
  data: {},
};
